import '../css/application_tailwind.css'
import '../css/footer.css'
import '@fortawesome/fontawesome-free/css/all';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import * as ActiveStorage from '@rails/activestorage';
import i18n from './i18n_js/index'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import '../css/vue-treeselect.scss'
import { globalEval } from 'jquery';

global.i18n = i18n;


global.setLanguage = function() {
  const locale = document.body.dataset.lang || 'en';
  global.i18n.locale = locale;
};

require("turbolinks").start();
require('@rails/activestorage').start();

ActiveStorage.start();

document.addEventListener("turbolinks:load", function() {
  global.i18n.locale = document.body.dataset.lang;
});

